<template>
  <div class="btn-wrapper">
    <a id="pwd-copy-btn" class=""
      :href="link"
      :class="classes"
      data-toggle="modal"
      data-target="#pwg-promo-modal"
      >
      <span>{{this.caption}}</span>
      <slot></slot>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Button',
  props: ['outlined', 'caption', 'link', 'newTab', 'disabled', 'classes']
}
</script>



// WEBPACK FOOTER //
// src/components/Button.vue